<div [ngClass]="{ show: showError }" id="error">
  <i class="fa fa-close"></i>{{ errorText }}
</div>

<div class="loader" [hidden]="showLoader">
  <i class="fa fa-spinner fa-spin"></i>
</div>
<div *ngIf="siteName == 'EroRentals' && showLoader" class="video-div">
  <div class="ero-banner-sub-div">
    <h2 class="ero-banner-heading">
      {{ bannerText1 }} <br />
      {{ bannerText2 }}
    </h2>
  </div>
  <video
    width="100%"
    height="600"
    autoplay="autoplay"
    loop="loop"
    muted="muted"
    playsinline="playsinline"
    style="object-fit: cover"
  >
    <source
      src="{{ appContext.context?.displaySetting?.bannerImage }}"
      type="video/mp4"
    />
  </video>
</div>
<div
  *ngIf="siteName !== 'EroRentals'"
  [ngClass]="appContext.siteName == 'Joy' ? 'joy-banner' : appContext.siteName == 'DemoPortal' ? 'joy-banner' : appContext.siteName === 'Sharecare' ? 'sharecare-banner' : 'banner'"
  [ngStyle]="{
    'background-image':
      appContext.siteName === 'Joy'
        ? 'linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url(' +
          banner +
          ')'
        : appContext.siteName === 'DemoPortal'
        ? 'linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url(' +
          banner +
          ')'
        : appContext.siteName === 'Sharecare' ? '  linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(' + banner + ')' :  'url(' + banner + ')'
  }"
>
  <h3 [ngClass]="appContext.siteName == 'Joy' ?   'joylife-title' : appContext.siteName == 'DemoPortal' ? 'joylife-title' :  appContext.siteName === 'Sharecare' ? ' raleway-extrabold  sharecare-title' :  'title'">
    <span [ngClass]=" appContext.siteName === 'Sharecare' ? '' : 'text-shadow'">{{ bannerText1 }}</span> <br />
    {{ bannerText2 }}
  </h3>
</div>
<div
  [ngClass]="
    appContext.siteName == 'EroRentals'
      ? 'ero-search-bar-container'
      : appContext.siteName == 'Joy'
      ? 'joy-search-bar-container'
      : appContext.siteName == 'DemoPortal'
      ? 'joy-search-bar-container demoportal-search-bar-container' :
      appContext.siteName === 'Sharecare' ? 'sharecare-search-bar-container'
      : 'search-bar-container'
  "
>
  <div class="search-box container-fluid container">
    <div class="search-bar" *ngIf="appContext.siteName !== 'DevDemo' || true">
      <!-- hard coded true to disable plug n play search widget on devdemo -->
      <travel-ui-search-hotels
        [submitBtnDisabled]="submitBtnDisabled"
        (getSearchOptions)="getSearchOptions($event)"
        [setAutoSuggestOptions]="autoSuggestOptions"
        (submit)="goToResultsPage($event)"
      >
      </travel-ui-search-hotels>
    </div>
  </div>
</div>
<div>
  <!-- ShamalGroup -->
  <div class="container" *ngIf="appContext.siteName == 'ShamalGroup'">
    <div class="sg-branding">
      <div class="width" *ngFor="let sg of shamalGroupList">
        <img src="{{ sg.image }}" alt="Image" style="width: 25%" />
        <h5 class="text">{{ sg.text }}</h5>
      </div>
    </div>
  </div>

  <div *ngIf="appContext.siteName == 'ShamalGroup'">
    <hr />
  </div>

  <section class="how-to" *ngIf="appContext.siteName == 'HotelCollection'">
    <h2 class="get-more">Receive a gift card based on your spending!</h2>
    <h2 class="get-more">Here's how it works:</h2>
    <div class="gift-card-blocks">
      <div class="gc-block">
        <span>Spend</span>
        <span><strong>$250 - $500</strong></span>
        <div class="gc-divider"></div>
        <span>Enjoy</span>
        <span><strong>a $25 gift card</strong></span>
      </div>
      <div class="gc-block">
        <span>Spend</span>
        <span><strong>$501 - $1000</strong></span>
        <div class="gc-divider"></div>
        <span>Enjoy</span>
        <span><strong>a $75 gift card</strong></span>
      </div>
      <div class="gc-block">
        <span>Spend</span>
        <span><strong>$1001 - $2000</strong></span>
        <div class="gc-divider"></div>
        <span>Enjoy</span>
        <span><strong>a $150 gift card</strong></span>
      </div>
      <div class="gc-block">
        <span>Spend over</span>
        <span><strong>$2000</strong></span>
        <div class="gc-divider"></div>
        <span>Enjoy</span>
        <span><strong>a $250 gift card</strong></span>
      </div>
    </div>
    <div class="fine-print-container">
      <span class="fine-print"
        >*Instant gift cards are not applicable for use in travel bookings.
        Instant gift cards are fully redeemable across all other Hotel
        Collection products.</span
      >
    </div>
  </section>

  <div
    *ngIf="siteContext?.enablePopularDestinations || hasStaticDeals"
    [ngClass]="appContext.siteName == 'HotelCollection' ? 'hc-deal-height' : ''"
  >
    <ng-container *ngIf="dealData; else dealsSkeleton">
      <div
        class="deals-container container-fluid container"
        *ngFor="let dealGroup of dealData"
      >
        <div class="header-container">
          <!-- <p class="icon"></p> -->
          <p
            [ngClass]="
              appContext.siteName == 'HotelCollection'
                ? 'hc-title'
                : appContext.siteName == 'ShamalGroup'
                ? 'sg-title'
                : 'title'
            "
          >
            {{ dealGroup.title }}
          </p>
          <p
            [ngClass]="
              appContext.siteName == 'ShamalGroup' ? 'sg-sub-title' : 'sub-title'
            "
          >
            {{ dealGroup.desc }}
          </p>
        </div>
        <ul class="deals">
          <li class="deal" *ngFor="let item of dealGroup.deals">
            <travel-ui-deal
              [item]="item"
              (dealSelected)="onDealSelect($event)"
            ></travel-ui-deal>
          </li>
        </ul>
      </div>
    </ng-container>
    <ng-template #dealsSkeleton>
      <div class="deals-container container-fluid container">
        <div class="header-container">
          <p class="skeleton skeleton-title-block"></p>
          <p class="skeleton skeleton-subtitle-block"></p>
        </div>
        <ul class="deals">
          <li class="deal" *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]">
            <div class="skeleton skeleton-deal-card"></div>
          </li>
        </ul>
      </div>
    </ng-template>
  </div>

  <!-- HostMyTrips -->
  <div class="container" *ngIf="appContext.siteName == 'HostMyTrips'">
    <div class="hmt-branding">
      <div class="width" *ngFor="let hmt of hostMyTripsGroupList">
        <a
          href="tel:7400097646"
          *ngIf="hmt.text == 'Assured Assistance'"
          class="hmt-branding-iconscontainer"
        >
          <img src="{{ hmt.image }}" alt="Image" style="width: 25%" />
          <h5 class="text">{{ hmt.text }}</h5>
        </a>
        <div
          *ngIf="hmt.text !== 'Assured Assistance'"
          class="hmt-branding-iconscontainer"
        >
          <img src="{{ hmt.image }}" alt="Image" style="width: 25%" />
          <h5 class="text">{{ hmt.text }}</h5>
        </div>
      </div>
    </div>
  </div>
  <!-- end-->

  <!-- OneStopParking -->
  <div class="container" *ngIf="appContext.siteName == 'OneStopParking'">
    <div class="hmt-branding">
      <div class="width" *ngFor="let hmt of oneStopParkingGroupList">
        <img src="{{ hmt.image }}" alt="Image" style="width: 25%" />
        <h5 class="text">{{ hmt.text }}</h5>
      </div>
    </div>
  </div>
  <!-- end-->

  <div *ngIf="appContext.siteName == 'HotelCollection'">
    <div class="container">
      <div style="text-align: center" class="col-sm-12">
        <div style="padding: 2rem 0rem 0rem 0rem">
          <h2 class="what-setusapart">What Sets Us Apart?</h2>
        </div>
        <div class="noHidden">
          <div class="noHiddenWidth">
            <div style="height: 50%">
              <img
                src="https://trvlsrv.hotelcollection.com/rewards/assets/images/section2%20icons%201.png"
                alt=""
                style="width: 28%"
              />
            </div>
            <h5><span class="noHiddenText">Book</span></h5>
            <h4>
              <span class="noHiddenPara"
                >Effortless booking with Travel by Hotel Collection! Gain access
                to exceptional hotel selections and make reserving your dream
                stay a breeze.</span
              >
            </h4>
          </div>
          <div class="noHiddenWidth">
            <div style="height: 50%">
              <img
                src="https://trvlsrv.hotelcollection.com/rewards/assets/images/section2%20icons-01.png"
                alt=""
                style="width: 28%"
              />
            </div>
            <h5><span class="noHiddenText">Save</span></h5>

            <h4>
              <span class="noHiddenPara"
                >Book with us and receive hundreds of dollars in gift cards! Use
                them to enhance your vacation with luxury Hotel Collection
                travel products.</span
              >
            </h4>
          </div>
          <div class="noHiddenWidth">
            <div style="height: 50%">
              <img
                src="https://trvlsrv.hotelcollection.com/rewards/assets/images/section2%20icons-02.png"
                alt=""
                style="width: 28%"
              />
            </div>
            <h5><span class="noHiddenText">Earn</span></h5>
            <h4>
              <span class="noHiddenPara"
                >Book with us and earn valuable gift cards! Use them to enhance
                your travel experience with luxury Hotel Collection travel
                products.</span
              >
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="container" style="padding-top: 3rem">
      <div class="col-sm-12" style="text-align: center">
        <div class="findResort col-sm-12">
          <h1 class="text1">Need a hotel?</h1>
          <p class="text2">
            Get in touch with a travel agent to get an exclusive deal.
          </p>
          <div>
            <button class="bookNow">
              <a href="tel:{{ supportNumber }}" class="support-number"
                >Call Us {{ supportNumber }}</a
              >
            </button>
          </div>
        </div>
        <div>
          <img class="bottomImage" src="./assets/images/needHotel.png" alt="" />
        </div>
      </div>
    </div>

    <div class="container">
      <div style="display: flex; justify-content: center">
        <h1 class="our-fav">Our favorites</h1>
      </div>

      <div class="row" style="display: flex; justify-content: center">
        <div
          *ngFor="let top of topPickHotelCollection; let index = index"
          class="destImage"
        >
          <img
            class="roomImages"
            src="{{ top.url }}"
            alt="image not found"
            (click)="toppick(top)"
          />
          <br />
          <div style="padding: 1rem 0.5rem 1rem 0.5rem">
            <span class="hotel-name">{{ top.name }}</span>
            <br />
            <span class="country-name">{{ top.country }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
